export default __webpack_public_path__ + "static/media/gallery_00.a80b8a72.jpg";